/**
 * This is the account service.
 * @memberOf Account Module
 * @namespace Account Service
 */

/**
 * @name AccountService
 * @desc Create the service.
 * @param $q
 * @param accountDataService
 * @memberOf Account Module.Account Service
 * @ngInject
 */
function accountFactory($q, accountDataService) {
    // Create the service.
    var service = {};
    return service;
}

export default accountFactory;



// WEBPACK FOOTER //
// ./src/login/account/account.service.js